import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, EventEmitter, Output } from '@angular/core';
import { SidenavService } from '../../../../shared/services/sidenav.service';
import { ApplistService } from '../../../../shared/services/applist.service';
import { TcmUtilsService } from '../../../../shared/services/tcmUtils.service';
import { HttpClient } from '@angular/common/http';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ListRange } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { AppViewService } from '../../../../shared/services/tcm-hub-appview.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { GroupService } from '../../shared/group.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { AdminService, PeriodicElement } from '../../../../shared';
import { MatPaginator } from '@angular/material/paginator';
import { NgModel } from '@angular/forms';
import { read, utils } from 'xlsx';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { environment } from '../../../../../environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSort } from '@angular/material/sort';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject, of } from 'rxjs';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-edit-group',
    templateUrl: './edit-group.component.html',
    styleUrls: ['./edit-group.component.scss'],
    providers: [NgModel],
    standalone: false
})
export class EditGroupComponent implements OnInit {
  displayedColumns: string[] = ['select', 'ApplicationID', 'ApplicationName', 'Category', 'App_Lifecycle_Status', 'reset_filter'];
  dataSource: MatTableDataSource<any>;
  selection = new SelectionModel<PeriodicElement>(true, []);
  displayedColumnSharing: string[] = ['select', 'userDetails'];
  dataSourceSharing!: MatTableDataSource<any>;
  selectionSharing = new SelectionModel<PeriodicElement>(true, []);
  displayedColumnDelegate: string[] = ['select', 'delegateUserDetails'];
  dataSourceDelegate: MatTableDataSource<any>;
  selectionDelegate = new SelectionModel<PeriodicElement>(true, []);
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('checkAll', { static: false }) checkBoxInput: ElementRef;
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  
  showLoader: boolean = false;
  groupName: any = '';
  SelectedGroupType: any;
  SelectedLob: any;
  FSLO: string = '';
  FAVC: string = '';
  Description: any = '';
  selectAll: boolean = false;
  selectallaskid: boolean = false;
  selectedApplicationName: any = [];
  selectTypeList: any = ["LOB", "SLO Owner", "Technical Owner", "Bulk Upload"];
  groupTypeList: any = ["Custom", "Platform"];
  groupType: any = "Platform";
  selectBy: any = "LOB";
  cioList: any = [];
  disabled: boolean;
  details: any;
  catogeryList: { name: any; }[];
  lifeCycleStatus: any;
  lobList: any = [];
  lobLists: any = [];
  LobSelected: any;
  sloOwner: any = [];
  tecOwner: any = [];
  techOwnerCache: any = [];
  sloOwnerCache: any = [];
  multiAppSelectAll: boolean = false;
  selectedsloOwner: string;
  selctedTecOwner: string;
  multiSelect: boolean = false;
  appliationSelectedLob: any = [];
  multiSelectAttr: string = '""';
  appList: any = [];
  selectedGloablAppCode = [];
  selectedFilter: any = [];
  public globalAskids = [];
  public appids = [];
  public searchStatus: any = false;
  public globalAppList = [];
  selectedTmdbCode: string;
  sortedapplist: any = [];
  detailsCache: any = [];
  askList: any = [];
  askGlobalIdList: any = [];
  private: any = true;
  public: any;
  visibility: any = "Private";
  editid: any;
  SelectedCIO: any = [];
  selectedCatagory: any = [];
  selectedLifecycle: any = [];
  categoryselectall: boolean = false;
  lifecycleselectall: boolean = false;
  lobselectAll: boolean = false;
  CIO: string = '';
  applicationWithLob: any = [];
  applicationWithSloOwner: any = [];
  applicationWithTechOwner: any = [];
  initialRange: ListRange = { start: 0, end: 8 };
  people: any = [];
  peopleDelegate: any = [];
  peopleLoading = false;
  public msfilter: any;
  public msfilter1: any;
  public sharedusers: any = [];
  public delegatedusers: any = [];
  created_at: any;
  updated_at: any;
  groupname: any;
  selectedgroupapplist: any = [];
  groupEditManageApllicationsTable: any = [];
  groupEditShareUsersTable: any = [];
  groupEditDelegateUsersTable: any = [];
  LOB: any;
  lobmulitiSelectAll = false;
  Fowner: any;
  selectedPersons: any = [];
  selectedDelegatePersons: any = [];
  TempAppselected: any = [];
  TempUserselected: any = [];
  tempRow: any = [];
  tempDelegateUserselected: any = [];
  isAdminRole: any = false;
  Activetab = 0;
  isGroupOwner: any = true;
  isManageSharingVisible: any = true;
  public disableRemove: boolean = true
  public disableRevoke: boolean = true
  public disableDelegateRevoke: boolean = true
  limitExccedgp: boolean = false;
  limitExcced: boolean = false;
  limitExhaust: boolean = false;
  limitExhaustDes: boolean = false;
  oldGroupName: any;
  oldGroupType: any;
  oldDescription: any;
  oldVisibility: any;
  disableApply: boolean = true;
  disableAdd: boolean = true;
  disableShare: boolean = true;
  disableDelegateAdd: boolean = true;
  disableDelegate: boolean = true;
  Filepath: string = "";
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  fileToUpload: File = null;
  groupOwner: any;
  manageApplicationsList: any = [];
  oldDataSource : any[];
  allAppList: any;
  appIdFilterApplied : boolean = false;
  appNameFilterApplied : boolean = false;
  categoryFilterApplied : boolean = false;
  appLifecycleFilterApplied : boolean = false;
  appIdFilter = [];
  appNameFilter = [];
  categoryFilter = [];
  appLifecycleFilter = [];
  searchValue: string;
  filterList: any;
  filValue = [];
  filterLists: any = [];
  Allfilter = [];
  selectedColumn: string;
  searchTxt: string;
  previousSelection = [];
  selectedSloAppList = [];
  selectedTechAppList = [];
  Finalfilter = [];
  applicationListConst: any[];
  loggedInUserEmail: string;
  isDelegate: boolean = false;
  bindRes:any;
  resObjDelegate:any;
  resGrpUser:any;
  popupMsg:any;
  tempDelegateRow:any = [];
  filteredCioList: any = [];
  filteredSubLobList: any = [];
  filteredAppNameList: any = [];
  searchSharedUserTxt: any;
  searchDelegateUserTxt: any;
  shareSubject:Subject<string> = new Subject<string>();
  delegateSubject:Subject<string> = new Subject<string>();
  showOnlyShareTab: boolean = false;
  RequestId: any;
  TempDownloadsUserselected: any = [];
  sharedDownloadusersList: any = [];
  constructor(private sidenavService: SidenavService, private applistService: ApplistService,
    private readonly tcmUtilService: TcmUtilsService, public datepipe: DatePipe,
    private AppViewService: AppViewService, public toaster: ToastrService, private route: Router,
    private readonly router: ActivatedRoute, private readonly capabilityService: CommonModelService, 
    private container: ElementRef, public dialog: MatDialog,
    private ngmodel:NgModel,
     private sharedAuthService: SharedAuthService,
     public admnsrv: AdminService,
  ) { }
  ngOnInit(): void {
    this.loggedInUserEmail = JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
    this.Filepath = "assets/Group_Maintanence_BulkUpload.xlsx"
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.checkAccess();
      });
    } else {
      this.checkAccess();
    }
    this.router.queryParams.subscribe(params => {
      this.editid = params.Group_Key;
      if (params.manageShare) {
        this.Activetab = 2;
      }

      if (this.editid) {
        this.getGroups();
      }

      if (params['tab'] === 'share') {
         this.RequestId = params.RequestId;
         this.Activetab = 2; 
         this.showOnlyShareTab = true;
        this.getMyDownloads();
      }
    });
    this.disabled = false;
    this.sidenavService.getLobSubLobList().subscribe(data => {
      data = data.sort((a,b) => (a.name < b.name ? -1 : 1));
      data.forEach(element => {
        element.subLob.sort((a,b) => (a.sub_lob < b.sub_lob ? -1 : 1));
      });
      this.details = data;
      this.cioList = data.map(x => { return { name: x.lob, lob_id: x.lob_id, subLobnames: x.subLob.map(t => { return { subLob_id: t.SubLobID, subLob_name: t.sub_lob}} ) } });
    });
    this.getAppList();
    this.multiAppSelectAll = true;
    this.setUpSubjectForShare();
    this.setUpSubjectForDelegate();
  }
  checkAccess() {
    const isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    const userData =  this.sharedAuthService.getTechAccessData();
    if (userData && userData.Role.toLowerCase() == 'admin' && isAdminRole) {
      this.isAdminRole = true;
      this.groupType = 'Platform';
    }
  }
  ngOnChanges() {
    this.Filepath = "assets/Group_Maintanence_BulkUpload.xlsx"
    this.checkAccess();
    this.router.queryParams.subscribe(params => {
      this.editid = params.Group_Key;
      if (params.manageShare) {
        this.Activetab = 2;
      }

      if (this.editid) this.getGroups();
    });
    this.disabled = false;
  }

  filterDropdown(column) {
    this.selectedColumn = column;    
    this.searchValue = '';
    let index;
    this.searchTxt = '';

    if(column == 'ApplicationID')
      index = 0;
    else if (column == 'ApplicationName')
      index = 1;
    else if(column == 'Category')
      index = 2;
    else if(column == 'App_Lifecycle_Status')
      index = 3;
    this.trigger.toArray().forEach((item: MatMenuTrigger, i: number) => {
      if(i !== index && item.menuOpen) {
        item.closeMenu()
      }
    });

    if (column == 'ApplicationID') {
      if (this. appNameFilterApplied || this.categoryFilterApplied || this.appLifecycleFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.ApplicationID });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.ApplicationID });
      }
      this.filValue = this.appIdFilter;
      this.trigger.toArray()[0].openMenu();
    }
    if (column == 'ApplicationName') {
      if (this. categoryFilterApplied || this.appIdFilterApplied || this.appLifecycleFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.ApplicationName });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.ApplicationName });
      }
      this.filValue = this.appNameFilter;
      this.trigger.toArray()[1].openMenu();
    }
    if(column == 'Category') {
      if (this. appNameFilterApplied || this.appIdFilterApplied || this.appLifecycleFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Category });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Category });
      }
      this.filValue = this.categoryFilter;
      this.trigger.toArray()[2].openMenu();
    }
    if(column == 'App_Lifecycle_Status') {
      if (this. categoryFilterApplied || this.appIdFilterApplied || this.appNameFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.App_Lifecycle_Status });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.App_Lifecycle_Status });
      }
      this.filValue = this.appLifecycleFilter;
      this.trigger.toArray()[3].openMenu();
    }
    this.filterList = new Set([...this.filterList]);
    this.filterLists = Array.from(this.filterList);
  }

  selectionChange(event) {
    let newevent;
    if (this.selectedColumn == 'ApplicationID') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationID') this.Allfilter.splice(i, 1) });
          newevent = this.checkPrevious(event,this.appIdFilter);
          if(newevent.source._value.length > 0){
            this.appIdFilter = newevent.source._value;
            this.Allfilter.push({ column: 'ApplicationID', value: newevent.source._value });
          }else{
            this.appIdFilter = [];
          }
      this.trigger.toArray()[0].openMenu();
    }

    if (this.selectedColumn == 'ApplicationName') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationName') this.Allfilter.splice(i, 1) });
        newevent = this.checkPrevious(event,this.appNameFilter);
      if(newevent.source._value.length > 0){
        this.appNameFilter = newevent.source._value;
        this.Allfilter.push({ column: 'ApplicationName', value: newevent.source._value }) 
      } else {
        this.appNameFilter = [];
      }
      this.trigger.toArray()[1].openMenu();
    }

    if(this.selectedColumn == 'Category') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Category') this.Allfilter.splice(i, 1) });
        newevent = this.checkPrevious(event,this.categoryFilter);
      if(newevent.source._value.length > 0){
        this.categoryFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Category', value: newevent.source._value }) 
      } else {
        this.categoryFilter = [];
      }
      this.trigger.toArray()[2].openMenu();
    }
    if(this.selectedColumn == 'App_Lifecycle_Status') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'App_Lifecycle_Status') this.Allfilter.splice(i, 1) });
        newevent = this.checkPrevious(event,this.appLifecycleFilter);
      if(newevent.source._value.length > 0){
        this.appLifecycleFilter = newevent.source._value;
        this.Allfilter.push({ column: 'App_Lifecycle_Status', value: newevent.source._value }) 
      } else {
        this.appLifecycleFilter = [];
      }
      this.trigger.toArray()[3].openMenu();
    }
  }

  checkPrevious(event,prevArr:any = []) {
    this.previousSelection = prevArr;
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (this.filterLists.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (this.filterLists.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }
  
  applyLocalFilter() {
    this.searchTxt = '';
    let filterdata = this.oldDataSource;
    this.Finalfilter.forEach((a, i) => { if (a.column == this.selectedColumn) this.Finalfilter.splice(i, 1) });
    this.Allfilter.forEach((element) => {
      if(element.column == this.selectedColumn) {
        this.Finalfilter.push(element);
      }
    });
    this.appIdFilterApplied = false;
    this.appNameFilterApplied = false;
    this.categoryFilterApplied = false;
    this.appLifecycleFilterApplied = false;
    this.Finalfilter.forEach((e1) => {
      if (e1.column == 'ApplicationID') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.ApplicationID));
          this.filterLists = filterdata.map((item) => { return item.ApplicationID });
          this.appIdFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[0].closeMenu();
        }
      }

      if (e1.column == 'ApplicationName') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.ApplicationName));
          this.filterLists = filterdata.map((item) => { return item.ApplicationName });
          this.appNameFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[1].closeMenu();
        }
      }

      if (e1.column == 'Category') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Category));
          this.filterLists = filterdata.map((item) => { return item.Category });
          this.categoryFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[2].closeMenu();
        }
      }

      if (e1.column == 'App_Lifecycle_Status') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.App_Lifecycle_Status));
          this.filterLists = filterdata.map((item) => { return item.App_Lifecycle_Status });
          this.appLifecycleFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[3].closeMenu();
        }
      }
    });
    if (this.Finalfilter.length == 0) {
      this.dataSource.data = this.oldDataSource;
      this.dataSource.paginator = this.paginator.toArray()[0];
      this.dataSource.sort = this.sort;
    }
    if(this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if(this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }
  }

  clearLocalFilter() {
    this.searchTxt = '';
    this.previousSelection = [];
    if(this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if(this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }

    if (this.selectedColumn == 'ApplicationID') {
      this.appIdFilter = [];
      this.appIdFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationID') this.Allfilter.splice(i, 1) });
      this.Finalfilter.forEach((a, i) => { if (a.column == 'ApplicationID') this.Finalfilter.splice(i, 1) });
    }
    if (this.selectedColumn == 'ApplicationName') {
      this.appNameFilter = [];
      this.appNameFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'ApplicationName') this.Allfilter.splice(i, 1) });
      this.Finalfilter.forEach((a, i) => { if (a.column == 'ApplicationName') this.Finalfilter.splice(i, 1) });
    }
    if(this.selectedColumn == 'Category') {
      this.categoryFilter = [];
      this.categoryFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Category') this.Allfilter.splice(i, 1) });
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Category') this.Finalfilter.splice(i, 1) });
    }
    if(this.selectedColumn == 'App_Lifecycle_Status') {
      this.appLifecycleFilter = [];
      this.appLifecycleFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'App_Lifecycle_Status') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'App_Lifecycle_Status') this.Allfilter.splice(i, 1) });
    }
    this.applyLocalFilter();
  }

  clearallFilter(isReqForAddorRemove:boolean = false) {
    if(this.trigger.toArray()[0]){
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]){
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]){
      this.trigger.toArray()[2].closeMenu();
    }
    if(this.trigger.toArray()[3]){
      this.trigger.toArray()[3].closeMenu();
    }

    this.appIdFilter = [];
    this.appNameFilter = [];
    this.categoryFilter = [];
    this.appLifecycleFilter = [];

    this.appIdFilterApplied = false;
    this.appNameFilterApplied = false;
    this.categoryFilterApplied = false;
    this.appLifecycleFilterApplied = false;
    this.Allfilter = [];
    this.Finalfilter = [];
    if(!isReqForAddorRemove){
      this.dataSource.data = this.oldDataSource;
      this.dataSource.paginator = this.paginator.toArray()[0];
      this.dataSource.sort = this.sort;
    }
  }
  sortData(event) {
    let sort: any[] = [];
    if (event.direction) {
      sort = [[event.active, event.direction]];
    }
    this.sortChangeEvent.emit(sort);   
  }

  focus() {
    if (this.oldGroupType !== this.groupType || this.oldVisibility !== this.visibility) {
      this.disableApply = false;
    } else {
      this.disableApply = true;
    }

  }
  focusDes() {
    if (this.oldDescription !== this.Description)
      this.disableApply = false
    else
      this.disableApply = true;
    if (this.Description.length <= 300) {
      this.limitExcced = false;
    }
    if (this.Description.length >= 300) {
      this.limitExhaustDes = true;
    }
    else
      this.limitExhaustDes = false;
  }
  focusgp() {
    if (this.oldGroupName !== this.groupname)
      this.disableApply = false
    else
      this.disableApply = true;
    if (this.groupname.length <= 60) {
      this.limitExccedgp = false;
    }
    if (this.groupname.length >= 60) {
      this.limitExhaust = true;
    }
    else
      this.limitExhaust = false;

  }

  getMyDownloads(){
     this.admnsrv.getMyDownload(this.RequestId).subscribe((response: any) => {
    if(response){
       this.sharedusers = response[0].sharedusers ? response[0].sharedusers.split(';') : [];
       this.groupEditShareUsersTable = this.sharedusers.map((item) => {
          let userEmail = item.split(':') 
        return {
          userDetails: item //userEmail[0]
        }
      });

       this.dataSourceSharing = new MatTableDataSource(this.groupEditShareUsersTable);
       this.dataSourceSharing.paginator = this.paginator.toArray()[1];
    }
     })
  }

  getGroups() {
    const data = {
      Group_Key: this.editid
    };
    this.AppViewService.getgroup(JSON.stringify(data)).subscribe((res: any) => {
      if(res){
        let appSize =0;
      
        this.oldGroupName = this.groupname = res[0].groupname;
        this.oldGroupType = this.groupType = res[0].Group_Type;
        this.oldDescription = this.Description = res[0].Group_Description;
        this.oldVisibility = this.visibility = res[0].Visibility;
        this.created_at = res[0].createdat;
        this.updated_at = res[0].updatedat;
        
        appSize=res[0]['applications'].length;
        for( let i=0 ; i< appSize;i++){
      this.selectedGloablAppCode[i] = res[0]['applications'][i].ASK_GLOBAL_ID;
      this.selectedgroupapplist[i] = res[0]['applications'][i].LONG_APP_NAME;
      }
      this.sharedusers = res[0].Sub_Author ? res[0].Sub_Author.split(',') : [];
      this.delegatedusers = res[0].delgates ? res[0].delgates.split(',') : [];
      if(this.delegatedusers.includes(this.loggedInUserEmail)) {
        this.isDelegate = true;
      }
      this.groupOwner = res[0].Author;
      this.groupEditManageApllicationsTable = this.selectedgroupapplist.map((item, i) => {
        return {
          ApplicationID: this.selectedGloablAppCode[i] || '0000',
          ApplicationName: item,
          Category: " ",
          App_Lifecycle_Status: " "
        }
      });
      const appIds = this.groupEditManageApllicationsTable.map(x => x.ApplicationID);
      this.AppViewService.getManageAppList(appIds).subscribe((res: any) => {
        this.manageApplicationsList = res.applicationList;
        this.oldDataSource = this.manageApplicationsList;
        this.dataSource = new MatTableDataSource(this.manageApplicationsList);
        this.selection = new SelectionModel<PeriodicElement>(true, []);
        this.dataSource.paginator = this.paginator.toArray()[0];
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = function (record, filter) {
          return record.ApplicationName.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1 ||
            record.ApplicationID.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
        }

      });

      this.groupEditShareUsersTable = this.sharedusers.map((item) => {
        return {
          userDetails: item
        }
      });

      this.groupEditDelegateUsersTable = this.delegatedusers.map((item) => {
        return {
          delegateUserDetails: item
        }
      });

      this.dataSourceSharing = new MatTableDataSource(this.groupEditShareUsersTable);
      this.selectionSharing = new SelectionModel<PeriodicElement>(true, []);
      this.dataSourceSharing.paginator = this.paginator.toArray()[1];
      this.dataSourceSharing.filterPredicate = function (record, filter) {
        return record.userDetails.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
      };

      this.dataSourceDelegate = new MatTableDataSource(this.groupEditDelegateUsersTable);
      this.selectionDelegate = new SelectionModel<PeriodicElement>(true, []);
      this.dataSourceDelegate.paginator = (this.visibility == 'Private') ? this.paginator.toArray()[2] : (this.paginator.toArray()[2]);
      this.dataSourceDelegate.filterPredicate = function (record, filter) {
        return record.delegateUserDetails.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
      };
      const loggedInUserEmail = sessionStorage.getItem('loggedInUserEmail');
      if (this.delegatedusers.indexOf(loggedInUserEmail.substring(1, loggedInUserEmail.length - 1)) !== -1) {
        this.isGroupOwner = false;
      }
      if (this.groupType == 'Platform' && this.visibility == 'Public') {
        this.isManageSharingVisible = false;
      }
    }
    }, (err) => {
      console.log(err);
    });

  }
  OnFilterApp() {
    this.appList = [];
    if(this.selectedsloOwner) {
      this.selectedSloAppList.filter(item => {
        Object.keys(item).some(key => {
          if(String(item[key]).toLowerCase().includes(this.FAVC.toLowerCase()))
            this.appList.push(item);
        });
      });
      this.appList = this.removeDup(this.appList);
      this.selectedApplicationName = this.appList;
      this.TempAppselected = this.selectedApplicationName;
      return this.appList;
    }
    else if (this.selctedTecOwner) {
      this.selectedTechAppList.filter(item => {
        Object.keys(item).some(key => {
          if(String(item[key]).toLowerCase().includes(this.FAVC.toLowerCase()))
            this.appList.push(item);
        });
      });
      this.appList = this.removeDup(this.appList);
      this.selectedApplicationName = this.appList;
      this.TempAppselected = this.selectedApplicationName;
      return this.appList;
    }
    if (this.FAVC != '' && this.FAVC.length >= 3) {
      let count = 0;
      for(let i=0; i < this.allAppList.length && count < 500; i++) {
        if(this.allAppList.length > i) {
          Object.keys(this.allAppList[i]).some(key => {
            if(String(this.allAppList[i][key]).toLowerCase().includes(this.FAVC.toLowerCase())) {
              this.appList.push(this.allAppList[i]);
              count = count + 1;
            }
          });
        }
        else {
          break;
        }
      }
    } 
    else {
      this.appList = this.applicationListConst.slice(0,500);
    }
    return this.appList;
  }
  getAppList() {
    this.showLoader = true;
    this.applistService.getAllApplications().subscribe((data:any[]) => {
      this.details = data;
      this.details = this.removeDup(this.details).sort(this.tcmUtilService.sortOnProperty('LONG_APP_NAME'));
      this.applicationListConst = this.details;
      this.detailsCache = this.details;
      this.applicationListConst = this.details;
      this.appList = this.applicationListConst.slice(0,500);
      this.allAppList = this.applicationListConst;
      this.appList.forEach(item => {
        if (this.groupEditManageApllicationsTable.filter(function (el) {
          return el.ApplicationID == item.ASK_GLOBAL_ID
        }).length > 0) {
          item.disable = true
        }
        else {
          item.disable = false
        }
      });
      this.askList = this.appList;
      this.sortedapplist = this.details.sort(this.tcmUtilService.sortOnProperty('LONG_APP_NAME'));
      for (let count = 0; count < this.appList.length; count++) {
        this.askGlobalIdList.push(this.appList[count].ASK_GLOBAL_ID);
      }
      this.showLoader = false;
    });
    this.applistService.getAllSlo().subscribe((data: any[]) => {
      this.sloOwnerCache = data.sort(this.tcmUtilService.sortOnProperty('name'));
      this.sloOwner = this.sloOwnerCache.slice(0,500);
    });
    this.applistService.getAllTechOwners().subscribe((data: any[]) => {
      this.techOwnerCache = data.sort(this.tcmUtilService.sortOnProperty('name'));
      this.tecOwner = this.techOwnerCache.slice(0,500);
    });
  }

  saveGroup(loggedusermail) {
    if (this.groupType === 'Custom') {
      this.visibility = "Private";
    } else {
      this.visibility = this.visibility ? this.visibility : this.private;
    }
    if (this.selectedApplicationName.length > 0) {
      const data = {
        GLOBAL_APP_ID: JSON.stringify(this.selectedGloablAppCode),
        LONG_APP_NAME: JSON.stringify(this.selectedApplicationName),
        visibility: this.visibility,
        groupname: this.groupName.trim(),
        Group_Type: this.groupType,
        created_at: this.datepipe.transform(Date(), 'dd MMM yy hh:mma'),
        author: loggedusermail,
        Group_Description: this.Description
      };


      const ServicePromise = this.AppViewService.addgroup(JSON.stringify(data));
      ServicePromise.then(res => {
        if(res) {
          this.toaster.success("Group updated successfully.", '', { timeOut: 10000, positionClass: 'toast-top-center' });
          this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
        }
      }).catch(err => {
        console.log(err);
      });
    } else {
      this.toaster.error("Please select applications to add in group!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
    }
  }
  submitgroup() {
    const loggedusermail =
      JSON.parse(sessionStorage.getItem('loggedInUserEmail')) || JSON.parse(sessionStorage.getItem('loggedInUserEmail'));

    if (!loggedusermail) {
      return;
    }

    if (!this.editid) {
      this.saveGroup(loggedusermail);
    }
  }

  onItemChange(value) {
    this.visibility = value;
    this.focus();
  }

  onGroupTypeChanged(event) {
    this.groupType = event.value;
    if (event.value === 'Custom') {
      this.visibility = "Private";

    }
    this.focus();
  }
  onSelectByChanged(event) {

    this.disableAdd = true;
    this.selectBy = event.value;
    this.resetAppFilters();
  }

  getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  onCIOChanged() {
    const selectedCioIds = this.SelectedCIO.map(cio => {
      return cio.lob_id;
    })
    this.lobLists = [];
    const selectedloblist = [];
    this.SelectedLob = [];
    this.cioList.map(cio => {
      if(selectedCioIds.includes(cio.lob_id)) {
        cio.subLobnames.forEach(subLob => {
          this.lobLists.push(subLob);
          selectedloblist.push(subLob);
        });
      }
    })
    this.SelectedLob = this.removeDup(selectedloblist);
    this.allAppList = [];
    this.appList = [];
    this.applicationListConst.forEach(element => {
      if(selectedCioIds.includes(element['LOB_ID'])) {
        if(this.appList.length <= 500)
          this.appList.push(element);
        this.allAppList.push(element);
      }
    });
  }

  onLOBChanged() {
    const selectedLobIds = this.SelectedLob.map(lob => {
      return lob.subLob_id;
    });
    this.allAppList = [];
    this.appList = [];
    this.applicationListConst.forEach(element => {
      if(selectedLobIds.includes(element['SubLOB_ID'])) {
        if(this.appList.length <= 500)
          this.appList.push(element);
        this.allAppList.push(element);
      }
    });
  }

  removeDup(list) {
    return list.filter((item, pos) => { return list.indexOf(item) == pos; })
  }

  onTecOwnerChanged(technicalOwner) {
    this.showLoader = true;
    this.selctedTecOwner = technicalOwner.value;
    this.appList = [];
    this.selectedTechAppList = [];
    this.allAppList = [];
    this.applicationListConst.forEach(app => {
      if(this.selctedTecOwner == app['Technical_Owner']) {
        this.appList.push(app);
      }
    });
    this.appList = this.removeDup(this.appList);
    this.allAppList = this.appList;
    this.selectedApplicationName = [];
    this.appList.forEach(item => {
      if (this.groupEditManageApllicationsTable.filter(function (el) {
        return el.ApplicationID == item.ASK_GLOBAL_ID
      }).length > 0) {
        item.disable = true
      }
      else {
        item.disable = false
        this.selectedApplicationName.push(item);
      }
    });
    this.selectedTechAppList = this.appList;
    this.multiAppSelectAll = true;
    this.TempAppselected = this.selectedApplicationName;
    if (this.selectedApplicationName.length > 0) {
      this.disableAdd = false;
    }
    this.updateSelectAllStatus(this.selectedTechAppList); // update select all status
    this.showLoader = false;
  }


  /**This method is used for fetching the Application list
    * for respective Technical Owner. And we can apply validations 
    * whether we need to disable it or not
    */
  selecttechAppName() {
    this.multiAppSelectAll = true;
    const preselect = [];
    let flag = 0;
    this.appList.forEach(item => {
      if (this.groupEditManageApllicationsTable.filter(function (el) {
        return el.ApplicationID == item.ASK_GLOBAL_ID
      }).length > 0) {
        item.disable = true
        flag = 1;
      }
      else {
        item.disable = false
        preselect.push(item);
      }
    });
    this.selectedApplicationName = preselect;
    this.TempAppselected = this.selectedApplicationName;
    if (flag == 0) {
      this.selectAll = true;
    }
    if (this.selectedApplicationName.length > 0) {
      this.disableAdd = false;
    }
  }



  onSloOwnerChanged(event) {
    this.showLoader = true;
    const selectedSLO = event.value;
    this.appList = [];
    this.selectedSloAppList = [];
    this.allAppList = [];
    this.applicationListConst.forEach(app => {
      if(selectedSLO == app['SERVICE_LEVEL_OWNER']) {
        this.appList.push(app);
      }
    });
    this.appList = this.removeDup(this.appList);
    this.allAppList = this.appList;
    this.selectedApplicationName = [];
    this.appList.forEach(item => {
      if (this.groupEditManageApllicationsTable.filter(function (el) {
        return el.ApplicationID == item.ASK_GLOBAL_ID
      }).length > 0) {
        item.disable = true
      }
      else {
        item.disable = false
        this.selectedApplicationName.push(item);
      }
    });
    this.selectedSloAppList = this.appList;
    this.multiAppSelectAll = true;
    this.TempAppselected = this.selectedApplicationName;
    if (this.selectedApplicationName.length > 0) {
      this.disableAdd = false;
    }
    this.updateSelectAllStatus(this.selectedSloAppList); // update select all status
    this.showLoader = false;
  }

  /**This method is used for fetching the Application list
   * for respective SLO Owner. And we can apply validations 
   * whether we need to disable it or not
   */
  selectsloAppName() {
    const preselectapp = [];
    let flag = 0;
    this.appList.forEach(item => {
      if (this.groupEditManageApllicationsTable.filter(function (el) {
        return el.ApplicationID == item.ASK_GLOBAL_ID
      }).length > 0) {
        item.disable = true
        flag = 1;
      }
      else {
        item.disable = false
        preselectapp.push(item);
      }
    });
    this.selectedApplicationName = preselectapp;
    this.TempAppselected = this.selectedApplicationName;
    if (flag == 0) {
      this.selectAll = true;
    }
    if (this.selectedApplicationName.length > 0) {
      this.disableAdd = false;
    }
  }


  /**
   * method to reset to top when options is closed
   * @param opened param to tell if select options are opned
   * @param viewPort  reference of virtual scroll viewport which is to be reset
   */
  openedChange(opened, viewPort: CdkVirtualScrollViewport) {
    if (!opened) {
      viewPort.setRenderedContentOffset(0);
      viewPort.setRenderedRange(this.initialRange);
    }
  }

  onAplicationValueChanged(event) {
    this.TempAppselected = event.value;
    if (this.TempAppselected.length > 0) {
      this.disableAdd = false;
      this.selectedApplicationName = this.TempAppselected;
    }else{
      this.disableAdd = true;
    }
  }

  preupdateSelect() {
    this.selectedFilter = this.selectedApplicationName.length > 0 ? this.details.filter(x => this.selectedApplicationName.includes(x.LONG_APP_NAME)) : [];
  }

  resetAppFilters() {
    this.multiAppSelectAll = false;
    this.selctedTecOwner = undefined;
    this.selectedsloOwner = undefined;
    this.selectedApplicationName = [];
    this.sloOwner = this.sloOwnerCache.slice(0,500);
    this.tecOwner = this.techOwnerCache.slice(0,500);
    this.appList = this.applicationListConst.slice(0,500);
    this.allAppList = this.applicationListConst;
    this.SelectedLob = '';
    this.SelectedCIO = '';
    this.multiSelect = false;
    this.multiSelectAttr = '""';
    this.FSLO = '';
    this.FAVC = '';
    this.Fowner = '';
    this.globalAskids = [];
    this.appids = [];
    this.searchStatus = false;
    this.TempAppselected = [];
  }
  public loadPeople() {
    if (this.msfilter.length >= 4) {
      this.shareSubject.next(this.msfilter);
    }
  }

  //call api for user list for share
  getSearchedUserForShare(){
    return this.capabilityService.getLDAPUsers(this.msfilter);
  }

  //setting up subject for share
  setUpSubjectForShare() {
    this.shareSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(() => this.getSearchedUserForShare().pipe(
        catchError(() => {
          this.toaster.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          return of([]);
        })
      ))
    ).subscribe((users) => {
      this.disableExistingUsers(users,'share');
    },
      () => {
        // Handle error scenario
        this.toaster.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      });
  }

  //call api for user list
  getSearchedUserForDelegate(){
    return this.capabilityService.getLDAPUsers(this.msfilter1);
  }

  //setting up subject for delegate
  setUpSubjectForDelegate(){
    this.delegateSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(() => this.getSearchedUserForDelegate().pipe(
        catchError(() => {
          this.toaster.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          return of([]);
        })
      ))
    ).subscribe((users) => {
      this.disableExistingUsers(users,'delegate');
    },
      () => {
        // Handle error scenario
        this.toaster.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      });
  }
  

  /**
   * Parses the given string to check if it is valid JSON. If the string is valid JSON
   * and resolves to a string, the parsed string is returned. Otherwise, the original
   * value is returned.
   *
   * @param value - The string to be checked and potentially parsed as JSON. If null or
   * undefined, the function returns null.
   * @returns The parsed string if the input is valid JSON and resolves to a string;
   * otherwise, the original value is returned. If the input is null, null is returned.
   */
  parseIfJson(value: string | null): string | null {
    if (!value) return null;
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === 'string' ? parsed : value;
    } catch {
      return value; // Not JSON, return as-is
    }
  }

  //disabling user list for delegate
  disableExistingUsers(dataStream,type){
    const loggedInUserEmail = this.parseIfJson(sessionStorage.getItem('loggedInUserEmail'));
    dataStream.forEach(item => {
      if (item.mail == undefined || this.delegatedusers.indexOf(item.mail) !== -1 || loggedInUserEmail == item.mail) {
        item.disable = true
      }
      else {
        item.disable = false
      }
    });
    if(type == 'delegate'){
        this.handleDelegateData(dataStream);
    }else if(type == 'share'){
        this.handleShareData(dataStream);
    }
  }

  //handle the delegate operation after disabling the user
  handleDelegateData(dataStream){
    this.peopleDelegate = dataStream;
      if (this.tempDelegateRow && this.tempDelegateRow.length > 0) {
        this.peopleDelegate = this.mergeArrays(this.peopleDelegate, this.tempDelegateRow);
    }
  }

  //handle the share operation after disabling the user
  handleShareData(dataStream){
    this.people = dataStream;
    if (this.tempRow && this.tempRow.length > 0) {
      this.people = this.mergeArrays(this.people, this.tempRow);
    }
  }

  getPeopleData(row){
    const index = this.TempUserselected.indexOf(row.mail);
    const tempRowIndex = this.tempRow.findIndex(x => x.mail == row.mail);
    if( index != -1){
      this.TempUserselected.splice(index,1);
      this.TempDownloadsUserselected.splice(index,1);
      this.tempRow.splice(tempRowIndex,1);
    }else{
      this.TempUserselected.push(row.mail);
      this.TempDownloadsUserselected.push(`${row.mail} : ${row.cn} : ${row.displayName}`);
      this.tempRow.push(row);
    }
    this.addPeople(row);
  }

  public addPeople(row) {
    if(this.TempUserselected.length > 0){
      this.disableShare = false;
    }else{
      this.disableShare = true;
    }
    if (this.sharedusers.length + this.TempUserselected.length < 10) {
      this.TempUserselected = this.TempUserselected.filter(function (element) {
        return element !== undefined;
      });
      this.TempDownloadsUserselected = this.TempDownloadsUserselected.filter(function (element) {
        return element !== undefined;
      });
     

    } else {
      this.toaster.error("user can't be share more than 9 users", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      this.TempUserselected.pop();
      this.tempRow.pop();
      this.selectedPersons = this.selectedPersons.filter((item=> item != row.mail));
      return;
    }
  }
  update_group(f) {
    if (!this.validateBasicConstraints(f)) {
      return;
    }

    const data = this.prepareUpdateData();
    const dialogConfig = this.createDialogConfig();

    switch (this.Activetab) {
      case 0:
        this.handleGroupDetailsUpdate(data);
        break;
      case 1:
        this.handleManageApplicationsUpdate(dialogConfig);
        break;
      case 2:
        this.handleShareUsersUpdate(data, dialogConfig);
        break;
    }
  }

  private validateBasicConstraints(f): boolean {
    if (this.Activetab === 0 && !this.validateGroupDetails(f)) {
      return false;
    }

    if (this.sharedusers.length > 9) {
      f.submitted = false;
      this.toaster.error("User can't be share more than 9 people", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return false;
    }

    return true;
  }

  private validateGroupDetails(f): boolean {
    if (this.Description.length > 300) {
      f.submitted = false;
      this.limitExcced = true;
      return false;
    }

    if (this.groupname.length > 60) {
      f.submitted = false;
      this.limitExccedgp = true;
      return false;
    }

    if (this.Description.length == 300) { this.limitExhaustDes = false; }
    if (this.groupname.length == 60) { this.limitExhaust = false; }

    if (this.groupname === '' || this.groupname === undefined || this.Description === '' || this.Description === undefined) {
      f.submitted = false;
      this.toaster.error("Group Name or Description not provided!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return false;
    }

    return true;
  }

  private prepareUpdateData() {
    const data = {};
    if (this.Activetab === 0) {
      data['groupname'] = this.groupname;
      data['Group_Type'] = this.groupType;
      data['Group_Description'] = this.Description;
      data['visibility'] = this.visibility;
    }
    this.popupMsg = this.tempDelegateUserselected.length > 1 ? "Users" : "User";
    return data;
  }

  private createDialogConfig(): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.height = 'auto';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    return dialogConfig;
  }

  private handleGroupDetailsUpdate(data) {
    const groupName = { check_group: this.groupname };
    this.AppViewService.getgroup(JSON.stringify(groupName)).subscribe((res: any) => {
      if (res.length > 0 && res[0].Group_Key !== parseInt(this.editid)) {
        this.toaster.error("This group name already exists", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      } else {
        this.updateGroupDetails(data);
      }
    });
  }

  private updateGroupDetails(data) {
    const ServicePromise = this.AppViewService.updategroup(JSON.stringify(data), this.editid);
    ServicePromise.then(res => {
      if (res && this.Activetab === 0) {
        this.toaster.success("Details updated successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
        this.getGroups();
        this.disableApply = true;
      }
    }).catch(err => {
      console.log(err);
    });
  }

  private handleManageApplicationsUpdate(dialogConfig) {
    if (this.selectBy !== 'Bulk Upload') {
      this.handleManualApplicationUpdate(dialogConfig);
    } else {
      this.addapps();
    }
  }

  private handleManualApplicationUpdate(dialogConfig) {
    this.cleanSelectedApplicationNames();

    if (this.selectedApplicationName.length > 0) {
      this.showApplicationConfirmationDialog(dialogConfig);
    } else {
      this.toaster.error('Please select applications to add in group!', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    }
  }

  private cleanSelectedApplicationNames() {
    this.selectedApplicationName = this.selectedApplicationName.filter(app => app != undefined && app != null);
  }

  private showApplicationConfirmationDialog(dialogConfig) {
    dialogConfig.data = {
      title: 'Add Application Confirmation!',
      subTitle: `Are you sure to add ${this.selectedApplicationName.length} applications. Please click on Continue to Proceed.`,
      buttonName: 'Continue'
    };

    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data === 'save') {
        this.updateApplications();
      } else if (this.selectedApplicationName.length == 0) {
        this.disableAdd = true;
      }
    });
  }

  private updateApplications() {
    this.addapps();
    const payload = { 'ASK_GLOBAL_ID': this.TempAppselected.map(x => x.ASK_GLOBAL_ID) };
    
    const ServicePromise = this.AppViewService.updategroup(payload, this.editid);
    ServicePromise.then(res => {
      if (res && this.Activetab === 1) {
        this.toaster.success("Applications updated successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
        this.disableAdd = true;
        this.disableApplicationsInList(payload['ASK_GLOBAL_ID']);
        this.resetAppFilters();
      }
    }).catch(err => {
      console.log(err);
    });
  }

  private disableApplicationsInList(appIds: any[]) {
    if (appIds && appIds.length > 0) {
      appIds.forEach(item => {
        this.appList.forEach(el => {
          if (el.ASK_GLOBAL_ID == item) {
            el.disable = true;
          }
        });
      });
    }
  }

  private handleShareUsersUpdate(data, dialogConfig) {
    dialogConfig.data = {
      title: 'Share Users Confirmation!',
      subTitle: `Are you sure to share group with ${this.TempUserselected.length} users. Please click on Continue to Proceed.`,
      buttonName: 'Continue'
    };

    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data === 'save') {
       this.showOnlyShareTab == false ? this.updateSharedUsers(data) : this.updateSharedDownloadUsers(data);
      }
    });
  }

  private updateSharedUsers(data) {
    this.share();
    data['Sub_author'] = this.sharedusers.length > 0 
      ? this.sharedusers.filter(element => element !== undefined).join(',') 
      : '';

    const ServicePromise = this.AppViewService.updategroup(JSON.stringify(data), this.editid);
    ServicePromise.then(res => {
      if (res && this.Activetab === 2) {
        this.disableShare = true;
        this.msfilter = '';
        this.people = [];
        this.tempRow = [];
        this.toaster.success("Sharing updated successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      }
    }).catch(err => {
      console.log(err);
    });
  }

 private updateSharedDownloadUsers(data) {
    this.share();
    // Always store as mail:cn:displayName for My Downloads
    let sharedUsersList = this.sharedusers.length > 0
      ? this.sharedusers.filter(element => element !== undefined).join(' ;')
      : '';
       
      
    const body = {
      request_id: this.RequestId,
      shareUser: sharedUsersList
    }
    this.admnsrv.updateMyDownload(body).subscribe((res: any) => {
      if (res && this.Activetab === 2) {
        this.getMyDownloads()
        this.disableShare = true;
        this.msfilter = '';
        this.people = [];
        this.tempRow = [];
        this.toaster.success("Sharing updated successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      }
    }
      , (err) => {
        console.log("Error in updateMyDownload", err)
      })
  }

  navigateHomePage() {
    this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }
  isAllshareSelected() {
    const numSelected = this.selectionSharing.selected.length;
    const numRows = this.dataSourceSharing.filteredData.length;
    return numSelected === numRows;
  }
  isAllDelegateUsersSelected() {
    const numSelected = this.selectionDelegate.selected.length;
    const numRows = this.dataSourceDelegate.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.filteredData.forEach(row => this.selection.select(row));
    this.disableRemove = !this.isAllSelected()
  }
  mastershareToggle() {
    this.isAllshareSelected() ?
      this.selectionSharing.clear() :
      this.dataSourceSharing.filteredData.forEach(row => this.selectionSharing.select(row));
    if (this.dataSourceSharing.filteredData.length > 0)
      this.disableRevoke = !this.isAllshareSelected()
    else
      this.disableRevoke = true
  }

  masterDelegateToggle() {
    this.isAllDelegateUsersSelected() ?
      this.selectionDelegate.clear() :
      this.dataSourceDelegate.filteredData.forEach(row => this.selectionDelegate.select(row));
    if (this.dataSourceDelegate.filteredData.length > 0)
      this.disableDelegateRevoke = !this.isAllDelegateUsersSelected()
    else
      this.disableDelegateRevoke = true

  }
  checkVal(event, row) {
    if(event) this.selection.toggle(row);
    if (this.selection.selected.length > 0) {
      this.disableRemove = false
    } else {
      this.disableRemove = true
    }
  }
  checkShareVal(event, row) {
    if(event) this.selectionSharing.toggle(row);
    if (this.selectionSharing.selected.length > 0) {
      this.disableRevoke = false
    } else {
      this.disableRevoke = true
    }
  }

  checkDelegateVal(event, row) {
    if(event) this.selectionDelegate.toggle(row) ;
    if (this.selectionDelegate.selected.length > 0) {
      this.disableDelegateRevoke = false
    } else {
      this.disableDelegateRevoke = true
    }
  }


  searchDataSet(event) {
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  searchUsersDataSet(event) {
    this.searchSharedUserTxt = event;
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.dataSourceSharing.filter = filterValue.trim().toLowerCase();
  }

  searchDelegateUsersDataSet(event) {
    this.searchDelegateUserTxt = event;
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.dataSourceDelegate.filter = filterValue.trim().toLowerCase();
  }

  
  addapps() {
    if (this.TempAppselected.length > 0) {
      this.TempAppselected.forEach(item => {
        if (Array.isArray(item)) {
          item.forEach(arr => {
            if (this.selectedgroupapplist.indexOf(arr.LONG_APP_NAME) == -1) this.selectedgroupapplist.push(arr.LONG_APP_NAME);
            if (this.selectedGloablAppCode.indexOf(arr.ASK_GLOBAL_ID) == -1) this.selectedGloablAppCode.push(arr.ASK_GLOBAL_ID);
          });
        } else {
          if (this.selectedgroupapplist.indexOf(item.LONG_APP_NAME) == -1) this.selectedgroupapplist.push(item.LONG_APP_NAME);
          if (this.selectedGloablAppCode.indexOf(item.ASK_GLOBAL_ID) == -1) this.selectedGloablAppCode.push(item.ASK_GLOBAL_ID);
        }
      });
      this.groupEditManageApllicationsTable.push(...this.TempAppselected.map((item) => {
        return {
          ApplicationID: item.ASK_GLOBAL_ID,
          ApplicationName: item.LONG_APP_NAME,
          Category: " ",
          App_Lifecycle_Status: " "
        }
      }));
      const appIds = this.groupEditManageApllicationsTable.map(x => x.ApplicationID);
      this.AppViewService.getManageAppList(appIds).subscribe((res: any) => {
        this.manageApplicationsList = res.applicationList;
        this.oldDataSource = this.manageApplicationsList;
        this.dataSource = new MatTableDataSource(this.manageApplicationsList);
        this.selection = new SelectionModel<PeriodicElement>(true, []);
        this.dataSource.paginator = this.paginator.toArray()[0];
        this.dataSource.sort = this.sort;
        this.TempAppselected = [];
        this.clearallFilter(true);
      });

    } else if (this.selectBy === 'Bulk Upload') {
      let arrayBuffer;
      let exceljsondata;
      const fileReader = new FileReader();
      fileReader.onload = () => {
        arrayBuffer = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const arr = [];
        for (let i = 0; i < data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        const bstr = arr.join("");
        const workbook = read(bstr, {
          type: "binary"
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        exceljsondata = utils.sheet_to_json(worksheet, {
          raw: true,
          defval: "",
        });
        if (worksheet.A1.v !== 'Application_ID') {
          this.toaster.error('Invalid excel format', '', { timeOut: 10000, positionClass: 'toast-top-center' });
        } else if (exceljsondata.length === 0) {
          this.toaster.error('No applications found in excel. Minimum 1 application is required.');
        } else {
          const subTitliMsg = exceljsondata.length + ' Applications selected to be added. Please click on continue to proceed.';
          subTitliMsg.replace('\n/g', '<br/>');
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '400px';
          dialogConfig.hasBackdrop = true;
          dialogConfig.minHeight = '200px';
          dialogConfig.height = 'auto';
          dialogConfig.data = {
            title: 'Add Application Confirmation!',
            subTitle: subTitliMsg,
            buttonName: 'Continue'
          };

          const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(result => {
            if (result.data === 'save') {
              const appIds = exceljsondata.map(x => x.Application_ID);
              const data = {
                GLOBAL_APP_ID: appIds,
                author: this.groupOwner,
                updated_at: this.datepipe.transform(Date(), 'dd MMM yy hh:mma'),
                delegateUsers: this.delegatedusers
              };
              this.AppViewService.editGroupBulkUpload(data, this.editid).subscribe(res => {
                if (res) {
                  this.toaster.success("Applications added to the group. Details are sent to the Email", '', { timeOut: 10000, positionClass: 'toast-top-center' })
                  this.fileInput.nativeElement.value = "";
                  this.disableAdd = true;
                  if (this.editid) this.getGroups();
                }
              }, (err) => {
                console.log(err);
                this.toaster.error(err.error.message, '', { timeOut: 10000, positionClass: 'toast-top-center' })
              });
            }
          });
        }
      };
      fileReader.readAsArrayBuffer(this.fileToUpload);
    } else {
      this.toaster.error('Please select an application', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    }
  }
  share() {
     this.showOnlyShareTab ? this.TempDownloadsUserselected.forEach(item => {
        const [mail, cn, displayName] = item.split(':');
  // Check if sharedusers already has this mail
        const alreadyExists = this.sharedusers.some(u => (u.split(':')[0] === mail));
        if (!alreadyExists) {
            this.sharedusers.push(`${mail} : ${cn} : ${displayName}`);
           }
    }) : this.TempUserselected.forEach(item => {
      if (Array.isArray(item)) {
        item.forEach(arr => {
          if (this.sharedusers.indexOf(arr) == -1) this.sharedusers.push(arr);
        });
      } else {
        if (this.sharedusers.indexOf(item) == -1) this.sharedusers.push(item);
      }
    });
   
    this.groupEditShareUsersTable = this.sharedusers.map((item) => {  
      return {
        userDetails: item
      }
    });
    this.dataSourceSharing = new MatTableDataSource(this.groupEditShareUsersTable);
    this.dataSourceSharing.paginator = this.paginator.toArray()[1];
    this.selectedPersons = [];
    this.TempUserselected =[];
    this.TempDownloadsUserselected = []
    this.tempRow = [];
    
  }

 

  removegroupuser() {
    if (this.selectionSharing.selected.length > 0) {
      const subTitliMsg = `Are you sure to remove ${this.selectionSharing.selected.length} users`
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.autoFocus=false;
      dialogConfig.data = {
        title: 'Update Confirmation!',
        subTitle: subTitliMsg,
        buttonName: 'Continue'
      };
      const data = {
        updated_at: this.datepipe.transform(Date(), 'dd MMM yy hh:mma')
      };
      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result.data === 'save') {
          if(this.searchSharedUserTxt?.target && this.searchSharedUserTxt.target.value) {
            this.searchSharedUserTxt.target.value = '';
          }
          this.selectionSharing.selected.forEach((item) => {
            const index = this.groupEditShareUsersTable.indexOf(item);
            if (index !== -1) {
              this.groupEditShareUsersTable.splice(index, 1);
              this.sharedusers.splice(index, 1);
            }
          });

          this.disableRevoke = true;

          this.dataSourceSharing = new MatTableDataSource(this.groupEditShareUsersTable);
          this.dataSourceSharing.paginator = this.paginator.toArray()[1];
          this.selectionSharing = new SelectionModel<PeriodicElement>(true, []);
          this.showOnlyShareTab ?  this.removeMyDownloadUser(data) : this.removeGroupUser(data) 

          
        }
      })

    }
  }

  removeGroupUser(data){
         if (this.sharedusers.length > 0) {
            const subauthor = this.sharedusers.filter(function (element) {
              return element !== undefined;
            });
            data['Sub_author'] = subauthor.join(',');
          } else {
            data['Sub_author'] = '';
          }
          const ServicePromise = this.AppViewService.updategroup(JSON.stringify(data), this.editid);
          ServicePromise.then(res => {
            this.resGrpUser= res;
            if (this.Activetab === 2) {
              this.toaster.success("Sharing removed successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
            }
          }).catch(err => {
            console.log(err);
          });
  }

  removeMyDownloadUser(data){
 let finaluser = '';
           if (this.sharedusers.length > 0) {
            const subauthor = this.sharedusers.filter(function (element) {
              return element !== undefined;
            });
            finaluser = subauthor.join(';');
          } else {
            finaluser = '';
          }
             const body = {
      request_id: this.RequestId,
      shareUser: finaluser
    }
          this.admnsrv.updateMyDownload(body).subscribe((res: any) => {
      if (res && this.Activetab === 2) {
        this.getMyDownloads()
              this.toaster.success("Sharing removed successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
            
      }
    }
      , (err) => {
        console.log("Error in updateMyDownload", err)
      })
  }

  removegroupapp() {
    if (this.selection.selected.length === 0) {
      return;
    }

    const dialogConfig = this.createRemoveAppDialogConfig();
    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data === 'save') {
        this.processApplicationRemoval();
      }
    });
  }

  private createRemoveAppDialogConfig(): MatDialogConfig {
    const subTitliMsg = `Are you sure to remove ${this.selection.selected.length} applications`;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.height = 'auto';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'Update Confirmation!',
      subTitle: subTitliMsg,
      buttonName: 'Continue'
    };
    this.updated_at = this.datepipe.transform(Date(), 'dd MMM yy hh:mma');
    return dialogConfig;
  }

  private processApplicationRemoval() {
    const selectedApps = this.selection.selected;
    const deletePayload = { 'ASK_GLOBAL_ID': selectedApps.map(x => x['ApplicationID']) };
    
    this.AppViewService.deleteMappedApps(this.editid, deletePayload).subscribe(
      res => {
        if (res) {
          this.removeApplicationsFromLists(selectedApps);
          this.refreshApplicationDataSource();
        }
      },
      (err) => {
        console.log(err);
        this.toaster.error("Error occured!", '', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
    );
  }

  private removeApplicationsFromLists(selectedApps: any[]) {
    selectedApps.forEach((item) => {
      this.enableApplicationInList(item['ApplicationID']);
      this.removeFromManageApplicationsTable(item['ApplicationID']);
    });
  }

  private enableApplicationInList(applicationId: string) {
    this.appList.forEach((el) => {
      if (el.ASK_GLOBAL_ID == applicationId) {
        el.disable = false;
      }
    });
  }

  private removeFromManageApplicationsTable(applicationId: string) {
    this.groupEditManageApllicationsTable.forEach((element, i) => {
      if (element.ApplicationID === applicationId && i !== -1) {
        this.groupEditManageApllicationsTable.splice(i, 1);
        this.selectedgroupapplist.splice(i, 1);
        this.selectedGloablAppCode.splice(i, 1);
      }
    });
  }

  private refreshApplicationDataSource() {
    this.clearallFilter(true);
    const appIds = this.groupEditManageApllicationsTable.map(x => x.ApplicationID);
    
    this.AppViewService.getManageAppList(appIds).subscribe((res: any) => {
      this.manageApplicationsList = res.applicationList;
      this.oldDataSource = this.manageApplicationsList;
      this.dataSource = new MatTableDataSource(this.manageApplicationsList);
      this.selection = new SelectionModel<PeriodicElement>(true, []);
      this.dataSource.paginator = this.paginator.toArray()[0];
      this.dataSource.sort = this.sort;
      
      if (this.Activetab === 1) {
        this.toaster.success("Applications removed successfully!", '', { timeOut: 5000, positionClass: 'toast-top-center' });
        this.disableRemove = true;
      }
    });
  }

  /**
   * This method is for Appliction List SelectAll checkbox operations
   * @param checkAll 
   * @param select 
   * @param values 
   */

  selectAllAppName(checkAll, select: NgModel, values) {
    const selectObject = {};
    selectObject['value'] = [];
    let disabledAppCount = 0;
    values.forEach(item => {
      if (item.disable) {
        disabledAppCount++;
      }
    });

    if (checkAll && (disabledAppCount != values.length)) {
      select.update.emit(
        values.map(value => {
          if (value.disable != true) {
            selectObject['value'].push(value);
            return value;
          }


        })
      );
      this.onAplicationValueChanged(selectObject);
    } else {
      select.update.emit([]);
    }
  }





  hidepopup() {
    const ele = this.container.nativeElement.querySelector('.hover_bkgr_fricc') as HTMLInputElement;
    ele.style.display = 'none';
  }
  showpopup() {
    window.open(environment.docUrl + 'user-guide/group-maintenance/');
  }
  tabchange(event, f) {
    f.resetForm();
    this.Activetab = event.index;
  }
  appSelect() {
    if (this.appList.length == this.selectedApplicationName.length)
      this.selectAll = true
    else
      this.selectAll = false
  }

  public loadDelegatePeople() {
    if (this.msfilter1.length >= 4) {
      this.delegateSubject.next(this.msfilter1);
    }
  }

  mergeArrays(arr1,arr2){
    const map = new Map();
    arr1.forEach(item => map.set(item.mail, item));
    arr2.forEach(item => {
      if(!map.has(item.mail)){
        map.set(item.mail, item);
      }
    });
    return Array.from(map.values());
  }

  getDelegateData(row){
    const index = this.tempDelegateUserselected.indexOf(row.mail);
    const tempRowIndex = this.tempDelegateRow.findIndex(x => x.mail == row.mail);
    if( index != -1){
      this.tempDelegateUserselected.splice(index,1);
      this.tempDelegateRow.splice(tempRowIndex,1);
    }else{
      this.tempDelegateUserselected.push(row.mail);
      this.tempDelegateRow.push(row);
    }
    this.addDelegatePeople(row);
  }


  public addDelegatePeople(row) {
    this.disableDelegate = false;
    if(this.tempDelegateUserselected.length > 0){
      this.disableDelegateAdd = false;
    }else{
      this.disableDelegateAdd = true;
    }
    if (this.delegatedusers.length + this.tempDelegateUserselected.length >= 10) {
      this.toaster.error("Group can't be Delegate to more than 9 users", '', { timeOut: 10000, positionClass: 'toast-top-center' });
      this.tempDelegateUserselected.pop();
      this.tempDelegateRow.pop();
      this.selectedDelegatePersons = this.selectedDelegatePersons.filter((item=> item != row.mail));
      return;
    }
  }

  delegate() {
    let popupMsg: any;
    let addedUsers: any[];
    if (this.tempDelegateUserselected.length > 0) {
      addedUsers = this.delegatedusers
      addedUsers = addedUsers.concat(this.tempDelegateUserselected);

      if (this.tempDelegateUserselected.length > 1)
        popupMsg = "Users"
      else
        popupMsg = "User"
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus=false;
      dialogConfig.data = {
        title: 'Delegate Group Confirmation!',
        subTitle: `Group is being Delegated to ${this.tempDelegateUserselected.length} ${popupMsg}. Please click on Continue to Proceed.`,
        buttonName: 'Continue'
      };


      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result.data === 'save') {
          addedUsers = addedUsers.filter(function (x, i, a) {
            return a.indexOf(x) === i;
          });
          const body = {
            Delegated_Users: addedUsers.join(','),
            updatedby: this.sharedAuthService.getMsid(),
            Updatedby_Name: JSON.parse(sessionStorage.getItem('currentUser')),
            updatedat: this.datepipe.transform(Date(), 'dd MMM yy hh:mma')
          };
          const ServicePromise = this.AppViewService.groupDelegateAccess(JSON.stringify(body), this.editid);
          const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
          ServicePromise
          .then(() => delay(Math.random() * 2000))
            .then(res => {
              this.resObjDelegate = res;
              this.getGroups();
                this.dataSourceDelegate = new MatTableDataSource(this.delegatedusers);
                this.dataSourceDelegate.paginator = this.paginator.toArray()[1];
                this.selectionDelegate = new SelectionModel<PeriodicElement>(true, []);
                this.selectedDelegatePersons = [];
                this.tempDelegateUserselected = [];
                this.msfilter1 = '';
                this.disableDelegateAdd = true;
                this.peopleDelegate = [];
                this.toaster.success("Delegates Added successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
            }).catch(err => {
            console.log(err);
          });

        }
      });
    }
  }

  removegroupDelegateuser() {
    let popupMsg: any;
    if (this.selectionDelegate.selected.length > 0) {
      if (this.selectionDelegate.selected.length > 1)
        popupMsg = "Users"
      else
        popupMsg = "User"
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus=false;
      dialogConfig.data = {
        title: 'Revoke Delegate Access Confirmation!',
        subTitle: `Delegate Access is being Removed to ${this.selectionDelegate.selected.length} ${popupMsg}. Please click on Continue to Proceed.`,
        buttonName: 'Continue'
      };


      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result.data === 'save') {
          if( this.searchDelegateUserTxt?.target && this.searchDelegateUserTxt.target.value) {
            this.searchDelegateUserTxt.target.value = '';
          }
          const addedUsers = this.delegatedusers;
          this.selectionDelegate.selected.forEach((item) => {
            const index = addedUsers.indexOf(item["delegateUserDetails"]);
            if (index !== -1) {
              addedUsers.splice(index, 1);
            }
          });
          const body = {
            Delegated_Users: addedUsers.join(','),
            updatedby: this.sharedAuthService.getMsid(),
            Updatedby_Name: JSON.parse(sessionStorage.getItem('currentUser')),
            updatedat: this.datepipe.transform(Date(), 'dd MMM yy hh:mma')
          };
          const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
          const ServicePromise = this.AppViewService.groupDelegateAccess(JSON.stringify(body), this.editid);
          ServicePromise
          .then(() => delay(Math.random() * 2000))
            .then(res => {
              this.bindRes = res;
              this.dataSourceDelegate = new MatTableDataSource(this.delegatedusers);
                this.dataSourceDelegate.paginator = this.paginator.toArray()[1];
                this.selectionDelegate = new SelectionModel<PeriodicElement>(true, []);
                this.disableDelegateRevoke = true;
                //* Revoke case handle
                this.tempDelegateUserselected = [];
                this.msfilter1 = '';
                this.disableDelegateAdd = true;
                this.peopleDelegate = [];
                this.selectedDelegatePersons = [];
                for (let i = 0; i < addedUsers.length; i++) {
                  if (!this.selectedDelegatePersons.includes(addedUsers[i])) {
                    this.selectedDelegatePersons.push(addedUsers[i]);
                  }
                }

                this.getGroups();
                this.toaster.success("Access Revoked successfully!", '', { timeOut: 10000, positionClass: 'toast-top-center' });
            }).catch(err => {
              console.log(err);
          });

        }
      });
    }    
    //* Revoke case handle 
  
  }

  uploadFileEvt(files: FileList) {
    if (files && files.length) {
      this.fileToUpload = files.item(0);
      this.disableAdd = false;
    } else {
      this.fileToUpload = null;
    }
  }
 

  resetValue(){
    this.CIO = " ";
    this.ngmodel.reset(this.CIO);
  }

  resetInputForLob(){
    let blurData;
    if(this.CIO) {
      blurData = this.cioList.filter(x =>{
        return x.name.toString().toLowerCase().includes(this.CIO.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.CIO = "";
    }
  }

  resetInputForSubLob(){
    let blurData;
    if(this.LOB) {
      blurData = this.lobLists.filter(x =>{
        return x.subLob_name.toString().toLowerCase().includes(this.LOB.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.LOB = "";
    }
  }

  resetInputForSloOwner(){
    let blurData;
    if(this.FSLO) {
      blurData = this.sloOwnerCache.filter(x =>{
        return x.name.toString().toLowerCase().includes(this.FSLO.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.FSLO = "";
    }
  }

  resetInputForTechnicalOwner(){
    let blurData;
    if(this.Fowner) {
      //Using techOwnerCache to filter the data
      blurData = this.techOwnerCache.filter(x =>{
        return x.name.toString().toLowerCase().includes(this.Fowner.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.Fowner = "";
    }
  }

  resetInputValueForApplication(){
    let blurData;
    if(this.FAVC) {
      blurData = this.appList.filter(x =>{
        return (x.ASK_GLOBAL_ID.toString().toLowerCase().includes(this.FAVC.toLowerCase()) || x.LONG_APP_NAME.toString().toLowerCase().includes(this.FAVC.toLowerCase()));
      })
    }
    if (blurData && blurData.length < 1) {
      this.FAVC = "";
      this.appList = this.applicationListConst.slice(0, 500);
    }
  }

  checkWhetherCioIncludes(oneOfSelectedCio) {
    this.filteredCioList = [...this.cioList];
    let isInclude: boolean;
    this.filteredCioList.forEach(cioElem => {
      if (cioElem.name == oneOfSelectedCio.name) {
        isInclude = false;
      } else {
        isInclude = true;
      }
    });
    return isInclude;
  }

  
  checkWhetherSubLobIncludes(oneOfSelectedSubLob) {
    this.filteredSubLobList = [...this.lobLists];
    let isInclude: boolean;
    this.filteredSubLobList.forEach(subLobElem => {
      if (subLobElem.subLob_name.startsWith(this.LOB) && oneOfSelectedSubLob.subLob_name.startsWith(this.LOB)) {
        isInclude = false;
      } else {
        isInclude = true;
      }
    });
    return isInclude;
  }

  checkWhetherAppNameIncludes(oneOfSelectedAppName) {
    this.filteredAppNameList = [...this.appList];
    let isInclude: boolean;
   this.filteredAppNameList.forEach(appElem => {
      if (appElem.LONG_APP_NAME.startsWith(this.FAVC) && oneOfSelectedAppName.LONG_APP_NAME.startsWith(this.FAVC)) {
        isInclude = false;
      } else {
        isInclude = true;
      }
    });
    return isInclude;
  }

  //* This method is used to update the select all checkbox status based on the selected Application
  updateSelectAllStatus(list: any[]): void {
    this.selectAll = list.length > 0;
  }

}
